import { render } from "./Repo.vue?vue&type=template&id=1d2c7d90&scoped=true&ts=true"
import script from "./Repo.vue?vue&type=script&lang=ts"
export * from "./Repo.vue?vue&type=script&lang=ts"

import "./Repo.vue?vue&type=style&index=0&id=1d2c7d90&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d2c7d90"]])

export default __exports__